import { render } from "./index.vue?vue&type=template&id=63b45e60&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&name=HomeView"
export * from "./index.vue?vue&type=script&lang=ts&name=HomeView"

import "./index.vue?vue&type=style&index=0&id=63b45e60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b45e60"]])

export default __exports__